import { useStyles } from "./style";

export const BorderedText: React.FC<{ text: string; className?: string }> = ({
    text,
    className,
}) => {
    const { blackBox } = useStyles();
    return <div className={`${blackBox} ${className}`}>{text}</div>;
};